import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const Coaching = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getCoachingSummary: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month, flag, loggedEmpRole } = arg;
                return {
                    url: constants.GET_COACHING_SUMMARY,
                    params: { employeeNumber, year, month, flag, loggedEmpRole },
                };
            },
            providesTags: ['Coaching'],
        }),
        getEmployeeSearch: builder.query({
            query: (arg: any) => {
                const { searchedEmpNumber,searcherEmpNo, getAllEmps } = arg;
                return {
                    url: constants.GET_COACHING_EMPLOYEE_SEARCH,
                    params: { searchedEmpNumber,searcherEmpNo, getAllEmps},
                };
            },
        }),
        getCoachingGridSearch: builder.query({
            query: (arg: any) => {
                const { loggedEmpNumber, searchedEmpNumber, year, month, isTeamLead } = arg;
                return {
                    url: constants.GET_COACHING_GRID_SEARCH,
                    params: { loggedEmpNumber, searchedEmpNumber, year, month, isTeamLead },
                };
            },
            providesTags: ['Coaching'],
        }),
        getMyActivitySummary: builder.query({
            query: (arg: any) => {
                const { loggedEmpNumber, year, month } = arg;
                return {
                    url: constants.GET_COACHING_MYACTIVITY_SUMMARY,
                    params: { loggedEmpNumber, year, month },
                };
            },
            providesTags: ['Coaching'],
        }),
        deleteCoaching: builder.mutation({
            query: (arg: any) => ({
                url: constants.DELETE_COACHING,
                method: 'PUT',
                params: { coachingId: arg.coachingId, coachingItem: arg.coachingItem },
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: [
                'Coaching',
                'CoachingStrengthModal',
                'Coaching_Metric',
                'CoachingConversationModal',
                'CoachingGoalInfo',
                'CoachingGoal',
            ],
        }),
        getAllParentClients: builder.query({
            query: () => {
                return {
                    url: constants.ALL_PARENT_CLIENTS_WITH_MANAGERS,
                };
            },
        }),
        getManagers: builder.query({
            query: (arg: any) => {
                const params = new URLSearchParams();
                if (arg.parentClientIds && arg.parentClientIds.length > 0) {
                    arg.parentClientIds.forEach((id: any) => params.append('parentClientIds', id));
                }
                return `${constants.GET_MANAGERS}?${params?.toString()}`;
            },
        }),
        getParentClient: builder.query({
            query: (arg: any) => {
                return {
                    url: constants.GET_PARENT_CLIENT,
                    params: { employeeNumber: arg.employeeNumber },
                };
            },
        }),
        getTwoUpManagersPc: builder.query({
            query: (arg: any) => {
                const params = new URLSearchParams();
                if (arg.parentClientIds && arg.parentClientIds.length > 0) {
                    arg.parentClientIds.forEach((id: any) => params.append('parentClientIds', id));
                }
                return `${constants.TWO_UP_MANAGERS_PC}?${params?.toString()}`;
            },
        }),
        getOneUpTeamleadsPc: builder.query({
            query: (arg: any) => {
                const params = new URLSearchParams();
                if (arg.parentClientIds && arg.parentClientIds.length > 0) {
                    arg.parentClientIds.forEach((id: any) => params.append('parentClientIds', id));
                }
                return `${
                    constants.ONE_UP_TEAMLEADS_PC
                }?managerNumber=${arg.managerNumber?.toString()}&${params?.toString()}`;
            },
        }),
        getAssociatePc: builder.query({
            query: (arg: any) => {
                const params = new URLSearchParams();
                if (arg.parentClientIds && arg.parentClientIds.length > 0) {
                    arg.parentClientIds.forEach((id: any) => params.append('parentClientIds', id));
                }
                return `${
                    constants.ASSOCIATES_PC
                }?managerNumber=${arg.managerNumber?.toString()}&tlNumber=${arg.tlNumber?.toString()}&${params?.toString()}`;
            },
        }),
        getAgentNonMetricDiscussions: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month } = arg;
                return {
                    url: constants.GET_AGENT_NON_METRIC_DISCUSSIONS,
                    params: { employeeNumber, year, month },
                };
            },
        }),
        
        getAgentMetricDiscussions : builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month,scorecardVersionId } = arg;
                return {
                    url: constants.GET_AGENT_METRIC_DISCUSSIONS,
                    params: { employeeNumber, year, month,scorecardVersionId },
                };
            },
        }),
        getCAPData : builder.query({
            query: (arg: any) => {
                const { employeeNumber, entityTypeId, entityId } = arg;
                return {
                    url: constants.GET_CAP_DATA,
                    params: { employeeNumber, entityTypeId, entityId },
                };
            },
        }),

    }),
});

export const {
    useGetCoachingSummaryQuery,
    useGetEmployeeSearchQuery,
    useGetCoachingGridSearchQuery,
    useGetMyActivitySummaryQuery,
    useDeleteCoachingMutation,
    useGetAllParentClientsQuery,
    useGetManagersQuery,
    useGetParentClientQuery,
    useGetTwoUpManagersPcQuery,
    useGetOneUpTeamleadsPcQuery,
    useGetAssociatePcQuery,
    useGetAgentNonMetricDiscussionsQuery,
    useGetAgentMetricDiscussionsQuery,
    useGetCAPDataQuery,
} = Coaching;
